import { render, staticRenderFns } from "./surchargeTerms.vue?vue&type=template&id=66857227&"
import script from "./surchargeTerms.vue?vue&type=script&lang=js&"
export * from "./surchargeTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66857227')) {
      api.createRecord('66857227', component.options)
    } else {
      api.reload('66857227', component.options)
    }
    module.hot.accept("./surchargeTerms.vue?vue&type=template&id=66857227&", function () {
      api.rerender('66857227', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uiCustom/se/basic/surchargeTerms.vue"
export default component.exports